import httpClient from './httpClient';

const planningService = {
    getPlanning(time) {
        return httpClient.get(`/api/adv/planning/${time.startTime}/${time.endTime}`);
    },
    createModificationRequest(data){
        return httpClient.post('/api/adv/planning/modification-request',data);
    },
    deleteModificationRequest(id){
        return httpClient.delete(`/api/adv/planning/modification-request/${id}`);
    },
    getModificationRequests(data){
        return httpClient.get('/api/adv/planning/modification-requests');
    },
}

export default planningService;